/* eslint-disable import/prefer-default-export */
import { useContext } from 'react';
import RouterContext from './routerContext';
import { getQueryString } from './queryStrings';

/**
 * @description
 * custom Hook function to extract query string from url.
 * @returns {Object} Object with parsed query string.
 */
export function useQueryString() {
  const history = useContext(RouterContext);
  return getQueryString(history);
}
